import React from "react"

import SearchInputV2 from "../../../../components/SearchInputV2/SearchInputV2"
import ButtonSmallElongated from "../../../../components/Button/ButtonSmallElongated"

import AddSiteForm from "../AddSites"
import useSitesFilter from "./useSitesFilter"

import styles from "./sitesFilter.module.scss"
import Drawer from "../../../../components/Drawer/Drawer"
import MoreFilters from "./MoreFilters"
import useSitesAccess from "../../useSitesAccess"
import MultiSelectDropdown from "../../../../components/MultiSelectDropdown/MultiSelectDropdown"
import { useGetAllTagsQuery } from "../../../Common/commonService"
import downloadButton from "../../../../assets/images/download_button_outline.svg"
import ColumnSelector from "../../../../components/AgGridTable/Common/ColumnSelector"
import { useDispatch, useSelector } from "react-redux"
import { TStore } from "../../../../store/Store"
import { setVisibleColumns } from "../../SiteSlice"

const SitesFilter = ({ tableStates, tableFunctions }: any) => {
    const { states, functions } = useSitesFilter({ tableStates, tableFunctions })
    const { addSitesPermission, downloadSitesAccess } = useSitesAccess()
    const { data: getTagData } = useGetAllTagsQuery()
    const { visibleColumns } = useSelector((store: TStore) => store.sites)
    const dispatch = useDispatch()

    const handleVisibleColumns = (columns: any) => {
        dispatch(setVisibleColumns(columns))
    }

    return (
        <div className={styles.header_container}>
            <div className={styles.main_container}>
                <div className={`${styles.header_container_filters} ${styles.header_container_filters}`}>
                    <div className={styles.search_filter}>
                        <SearchInputV2
                            placeholder={"Search by Site Name/ID"}
                            onSearch={(value: string) => functions.handleFilterChange("site", value)}
                            searchIcon={true}
                            value={states.filterValues.site ?? ""}
                        />
                    </div>
                    <div className={styles.search_filter}>
                        <SearchInputV2
                            placeholder={"Search by Pincode"}
                            onSearch={(value: string) => functions.handleFilterChange("pincode", value)}
                            searchIcon={true}
                            value={states.filterValues.pincode ?? ""}
                        />
                    </div>
                    <div className={styles.search_filter}>
                        <MultiSelectDropdown
                            title="Select Tags"
                            options={getTagData?.data?.map((data: any) => {
                                return { id: data?.id, title: data?.name }
                            })}
                            id="tags"
                            width="155px"
                            dropdownWidth="155px"
                            onChange={() => {}}
                            selectedOptions={states?.filterValues.tags?.length ? states?.filterValues.tags : []}
                            onSelect={(value: any) => functions?.handleFilterChange("tags", value)}
                        />
                    </div>
                    <div className={styles.more_filters} onClick={functions.toggle}>
                        More filters...
                    </div>
                    <div className={styles.filter_reset} onClick={functions.resetFilters}>
                        Reset
                    </div>
                </div>

                {
                    <div className={styles.raise_ticket_container}>
                        <div className="d-flex justify-content-end align-items-center gap-4">
                            <ColumnSelector columns={visibleColumns} onSubmit={handleVisibleColumns} />
                            {downloadSitesAccess && (
                                <img
                                    src={downloadButton}
                                    alt="download"
                                    onClick={!states?.isSitesLoading ? functions?.handleDownload : undefined}
                                />
                            )}
                            {addSitesPermission && (
                                <div>
                                    <ButtonSmallElongated
                                        onClick={() => {
                                            functions.setOpenAddForm(true)
                                        }}>
                                        +Add Site{" "}
                                    </ButtonSmallElongated>
                                </div>
                            )}
                        </div>
                    </div>
                }
                <AddSiteForm openAddForm={states.openAddForm} setOpenAddForm={functions.setOpenAddForm} />

                {/* More Filters */}
                <Drawer
                    padding={"0px 0px 20px 0px"}
                    width={states.deviceType === "Mobile" ? "230px" : ""}
                    open={states.isShown}
                    handleClose={functions.toggle}
                    children={<MoreFilters functions={functions} states={states} />}
                />
            </div>
        </div>
    )
}

export default SitesFilter
